module.exports = __webpack_public_path__ + "static/media/hum.d95a97c3.png";